import React, { useContext, useEffect, useRef, useState, forwardRef } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
  Typography,
} from "@mui/material";
import OTPInput from "react-otp-input";
import ACRButton from "../../commanComponents/ACRButton";
import { String } from "../../constants/Strings";

import {
  styledACRButton,
  StyledDialogTitle,
  styledOTPInputProps,
  StyledResendOTP,
  StyleTypography,
} from "../../style/styleComponents/StyledOTPScreen";
import CustomSnackbar from "../../commanComponents/CustomerSnackbar";
import useOnboardingOTP from "../../Hooks/CustomHooks/useOnboardingOTP";
import useKeyboardAvoidance from "../../Hooks/CustomHooks/useKeyboardAvoidance";
import { getColor } from "../../style/color/color";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

// Transition effect for dialog popup
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const OTPScreen = ({
  openDialog,
  otp,
  setOtp,
  handleClose,
  onOTPHandleChange,
  handleAuthorize,
  OpenSnackbar,
  setOpenopenSnackbar,
  title,
  snackbarOTPEnter,
  setSnackbarOTPEnter,
  message,
  error,
  timer,
  securedMobileNumber,
  startTimer,
  setTimer,
}) => {
  const { resendEnable, resendOTP, setResendEnable, resendMessage } =
    useOnboardingOTP();
  const { keyboardOffset } = useKeyboardAvoidance();
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const { verifyData } = useContext(OTPVerifyContext);

  const handleCloseSnackar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenopenSnackbar(false);
  };

  const handleClickResendOTp = async () => {
    gaCustomEvent(String.gaEventName.acrLogin, String.gaEventClickName.acrLoginResendOtp, verifyData.customerId);
    resendOTP();
    setTimer(30);
    setOtp("");
    startTimer();
  };
  const handleCloseOTPSnackbar = () => {
    setSnackbarOTPEnter(false);
  };
  const otpInputRef = useRef(null);

  //useeffect for keyboard resize according device
  useEffect(() => {
    const initailHieght = window.innerHeight;
    const handleResize = () => {
      const currentHeight = window.innerHeight;
      setKeyboardOpen(currentHeight < initailHieght * 0.8);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Ensure the input field is focused when the dialog is opened
  useEffect(() => {
    if (openDialog && otpInputRef.current) {
      otpInputRef.current.focus();
    }
  }, [openDialog]);
  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          borderTopLeftRadius: "32px",
          borderTopRightRadius: "32px",
          textAlign: "center",
          p: 3,
          maxWidth: "100%",
          height: "500px",
          overflowY: "auto",
          margin: 0,
        },
      }}
    >
      <StyledDialogTitle id="alert-dialog-title">{title}</StyledDialogTitle>
      <DialogContent
        sx={{ p: 2, mt: 2, mb: 0, marginBottom: `${keyboardOffset + 20}px` }} //addedd
      >
        <StyleTypography variant="body2">
          {`OTP sent to +91 ${securedMobileNumber}`}
        </StyleTypography>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <OTPInput
            value={otp}
            onChange={(value) => {
              if (/^[0-9]*$/.test(value)) {
                onOTPHandleChange(value);
              }
            }}
            numInputs={6}
            renderInput={(props) => (
              <input
                {...props}
                inputMode="numeric"
                type="password"
                pattern="[0-9]*"
                autoComplete="one-time-code"
              />
            )}
            separator={<span style={{ width: "8px" }}></span>}
            isInputNum={true}
            inputType="number"
            shouldAutoFocus={false}
            secure={true}
            inputStyle={{
              ...styledOTPInputProps,
              backgroundColor:
                otp.length === 0 ? getColor.WhiteSmoke : getColor.PrimaryWhite,
              pb: `${keyboardOffset + 20}px`,
            }}
            inputProps={{
              sx: { width: "100%", textAlign: "center" },
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            mt: "20px",
          }}
        >
          <StyledResendOTP
            disabled={timer !== 0}
            timer={timer}
            onClick={timer !== 0 ? null : handleClickResendOTp}
          >
            Resend OTP
          </StyledResendOTP>
          <Typography
            sx={{
              lineHeight: "16px",
              fontWeight: 500,
              fontSize: { xs: "12px", md: "14px" },
            }}
          >
            {`in ${timer}s`}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: keyboardOpen ? "40" : "20",
          mb: keyboardOpen ? "20%" : "20%",
        }}
      >
        <ACRButton
          label={String.OTPScreen.Authorize}
          style={styledACRButton}
          onClickButton={handleAuthorize}
        />
      </DialogActions>

      <CustomSnackbar
        open={OpenSnackbar}
        handleClose={handleCloseSnackar}
        message={message}
        severity={String.successSeverity}
      />
      <CustomSnackbar
        open={snackbarOTPEnter}
        handleClose={handleCloseOTPSnackbar}
        message={error === "" ? error : String.OTPScreen.validOTPMessage}
        severity={String.ErrorSeverity}
      />
      <CustomSnackbar
        open={resendEnable}
        handleClose={() => setResendEnable(false)}
        message={resendMessage}
        severity={String.successSeverity}
      />
    </Dialog>
  );
};
